/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Price } from './price';

/**
 * (german: Schutzbrief)   (VMP: SCH)
 */
export interface RoadsideAssistance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
}
